import type { NodeToRenderProps } from '@src/components/custom-nodes/types';
import { atom } from 'jotai';

interface PopoverCoordinates {
  x: number | null;
  y: number | null;
}

export const popoverCoordinatesAtom = atom<PopoverCoordinates>({ x: null, y: null });

export const selectedNodePropsAtom = atom<NodeToRenderProps | null>(null);
